import React from 'react';
import styled, { css } from 'styled-components';
import { LockIconSimpleSmall } from 'src/assets/lock-icon-simple-small';
import { CollectionBadgeViewData } from '../types';

type CollectionBadgeProps = CollectionBadgeViewData;

/**
 * Pure presentational badge for collection cards.
 * Visibility logic (exclusive access, auth) is pre-computed by the container.
 */
export const CollectionBadge = ({ color, isExclusive, title }: CollectionBadgeProps): JSX.Element => (
  <Badge $color={color} $isExclusive={isExclusive}>
    {isExclusive && <LockIconSimpleSmall color='currentColor' />}
    {title}
  </Badge>
);

const Badge = styled.div<{
  $color: string | null;
  $isExclusive: boolean;
}>`
  align-items: center;
  color: ${({ $color }) => $color ?? 'currentColor'};
  display: flex;
  gap: 4px;
  justify-content: var(--justify-content, flex-start);
  width: 100%;

  ${({ $isExclusive }) =>
    !$isExclusive &&
    css`
      &::before {
        background: currentColor;
        content: '';
        height: 6px;
        margin: 0 3px;
        transform: rotate(45deg);
        width: 6px;
      }
    `}

  svg {
    width: 12px;
    height: 12px;
  }
`;
